/**
 * Copyright 2026, IntraLinks, Inc. All rights reserved.
 */

import React, { FC } from 'react';
import { IlLoading } from 'il-framework-component';
import { useTranslation } from 'react-i18next';
import { I18nNamespaces } from '../../utils/constants.util';
import styles from './LoaElevatingOverlay.scss';

const LoaElevatingOverlay: FC = () => {
  const { t } = useTranslation(I18nNamespaces.LOA_ENRICHMENT);

  return (
    <div className={styles.loaOverlay}>
      <div className={styles.loaOverlayContent}>
        <IlLoading active withOverlay={false} />
        <p>{t('loaEnrichment.common.loaElevation.popupInProgress')}</p>
      </div>
    </div>
  );
};

export default LoaElevatingOverlay;
